import TruckService from "./TruckService";

class UserService extends TruckService {

    updateFactoryStatusToOffline(factoryId, afterResponse) {
        this.sendPostRequest('makefactoryoffline', factoryId, afterResponse);
    }
    updateFactoryStatusToOnline(factoryId, afterResponse) {
        this.sendPostRequest('makefactoryonline', factoryId, afterResponse);
    }

}
export default UserService;
